<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("shortlink") }}</div>
    <div class="grid is-col-min-10">
      <!-- Card para gestionar perfiles -->
      <div class="cell" @click="manage_profiles">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/3135/3135715.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("manage profiles") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card para gestionar enlaces -->
      <div class="cell" @click="manage_links">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/3281/3281289.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("manage links") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card para configuraciones -->
      <!-- <div class="cell" @click="module_settings">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/2040/2040504.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("settings") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </section>
</template>

<script>
export default {
  name: "ShortlinkIndex",
  data() {
    return {};
  },
  methods: {
    manage_profiles() {
      this.$router.push({ name: "shortlink_profiles" });
    },
    manage_links() {
      this.$router.push({ name: "shortlink_links" });
    },
    module_settings() {
      this.$router.push({ name: "shortlink_settings" });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.card {
  cursor: pointer;
  transition: transform 0.2s;
}
.card:hover {
  transform: translateY(-5px);
}
</style>
